import { observer } from "mobx-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import CameraErrorComponent from "src/components/errors/CameraErrorComponent";
import { applicationStore } from "src/store/ApplicationStore";
import { useTranslation } from "react-i18next";

const CameraAccessError = observer(() => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const props = {
        title: t('cameraError.accessNeeded.title'),
        header: t('cameraError.accessNeeded.header'),
        previousPage: applicationStore.previousRoute.cameraError
    };
    return (
        <CameraErrorComponent {...props}>
            {window?.top === window?.self &&
                <Button
                    onClick={() => {
                        applicationStore.setContinueOnAnotherDevice("/error-access-camera");
                        return navigate("/continue-on-another-device", { replace: true });
                    }}
                    className=""
                    variant="primaryWithoutIcon"
                >
                    <span className="ms-2">{t('verification.continueAnotherDevice')}</span>
                </Button>}

            <div className="text-body text-Gray900 mt-5">
                <p>{t('cameraError.manual')}</p>
                <Link
                    to={applicationStore.previousRoute.cameraError}
                    className="text-SorrellBrown5000 underline font-bold cursor-pointer"
                    replace
                >
                    {t('cameraError.enabledLink')}
                </Link>
            </div>
        </CameraErrorComponent>
    );
});

export default CameraAccessError;
